import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LoginPromptComponent } from '@app/shared/components/login-prompt/login-prompt.component';

@Injectable({
  providedIn: 'root'
})
export class DialogService {

  constructor(private dialog: MatDialog) { }

  public showLoginRequiredDialog(): void {
    this.dialog.open(LoginPromptComponent, {
      width: '400px',
      disableClose: true
    });
  }
}
